<template>
    <div>
        <field-input
            field="reference"
            :value="row.reference"
            @updated="update"
        ></field-input>
        <div v-for="(value, field) in toggleFields" :key="field">
            <field-checkbox
                v-if="isField('button_is_block', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-checkbox>
            <field-checkbox
                v-if="isField('black_background', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-checkbox>
        </div>
        <div v-for="(value, field) in globalFields" :key="field">
            <field-title-size
                v-if="isField('title_size', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-title-size>
            <field-background-color
                v-if="isField('background_color', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-background-color>
            <field-image
                    v-if="isField('background_path', field)"
                    :field="field"
                    :value="`${value}`"
                    @updated="update"
            ></field-image>
            <field-image
                v-if="isField('image_path', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-image>
            <field-input
                    v-if="isField('video_path', field)"
                    :field="field"
                    :value="`${value}`"
                    @updated="update"
            ></field-input>
            <field-image
                v-if="isField('mobile_image_path', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-image>
            <field-left-right
                v-if="isField('left_right', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-left-right>
            <field-text-color
                v-if="isField('text_color', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-text-color>
            <field-products
                    v-if="isField('product_ids', field)"
                    :field="field"
                    :value="`${value}`"
                    @updated="update"
            ></field-products>
            <field-pages
                    v-if="isField('page_ids', field)"
                    :field="field"
                    :value="`${value}`"
                    @updated="update"
            ></field-pages>
            <field-video
                    v-if="isField('video_id', field)"
                    :field="field"
                    :value="value"
                    @updated="update"
            ></field-video>
            <field-gallery
                v-if="isField('gallery_id', field)"
                :field="field"
                :value="value"
                @updated="update"
            ></field-gallery>
            <field-article-type
                    v-if="isField('article_type', field)"
                    :field="field"
                    :value="`${value}`"
                    @updated="update"
            ></field-article-type>
            <field-article-tag
                    v-if="isField('tag_id', field)"
                    :field="field"
                    :value="value"
                    @updated="update"
            ></field-article-tag>
            <field-articles
                v-if="isField('article_ids', field)"
                :field="field"
                :value="`${value}`"
                @updated="update">
            </field-articles>
            <field-article-category
                v-if="isField('article_category_id', field)"
                :field="field"
                :value="value"
                @updated="update">
            </field-article-category>
            <field-input
                    v-if="isField('height', field)"
                    :field="field"
                    :value="value"
                    @updated="update"
            ></field-input>
            <field-input
                    v-if="isField('height_mobile', field)"
                    :field="field"
                    :value="value"
                    @updated="update"
            ></field-input>
            <field-input
                v-if="isField('maileon_tag', field) || isField('doi_key', field)"
                :field="field"
                :value="value"
                @updated="update"
            ></field-input>
            <field-checkbox
                v-if="isField('target_blank', field)"
                :field="field"
                :value="`${value}`"
                @updated="update"
            ></field-checkbox>
        </div>

        <tabs v-if="hasTranslatableFields">
            <tab :key="lang" :name="lang" v-for="(fields, lang) in translatableFields">
                <div v-for="(value, field) in fields" :key="field">
                    <div v-if="isField('video_id', field)">VIDEO EDITOR</div>
                    <field-image
                            v-if="isField('image', field)"
                            :field="field"
                            :lang="lang"
                            :value="`${value}`"
                            @updated="update"
                    ></field-image>
                    <field-checkbox
                            v-if="isField('hide', field)"
                            :field="field"
                            :lang="lang"
                            :value="!!parseInt(value)"
                            @updated="update"
                    ></field-checkbox>
                    <field-input
                            v-if="isField('video', field)"
                            :field="field"
                            :lang="lang"
                            :value="`${value}`"
                            @updated="update"
                    ></field-input>
                    <field-input
                            v-if="isField('image_alt', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-input>
                    <field-input
                            v-if="isField('mobile_image_alt', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-input>
                    <field-input-enterable
                            v-if="isField('title', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-input-enterable>
                    <field-input
                            v-if="isField('sub_title', field) || isField('question', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-input>
                    <field-textarea
                            v-if="isField('content', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-textarea>
                    <field-ckeditor
                            v-if="isField('content_ck', field) || isField('text_after_subscribing', field) || isField('answer', field) || isField('introduction', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-ckeditor>
                    <field-input
                            v-if="isField('button_label', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-input>
                    <field-input
                        v-if="isField('label', field)"
                        :field="field"
                        :lang="lang"
                        :value="value"
                        @updated="update"
                    ></field-input>
                    <field-input
                            v-if="isField('button_link', field)"
                            :field="field"
                            :lang="lang"
                            :value="value"
                            @updated="update"
                    ></field-input>
                    <field-input
                        v-if="isField('link', field)"
                        :field="field"
                        :lang="lang"
                        :value="value"
                        @updated="update"
                    ></field-input>
                </div>
            </tab>
        </tabs>
        <div v-if="isDummy">
            No fields available for this row type.
        </div>
    </div>
</template>

<script>
    import fieldInput from './fields/Input';
    import fieldInputEnterable from './fields/InputEnterable';
    import fieldNumber from './fields/Number';
    import fieldCheckbox from './fields/Checkbox';
    import fieldTextarea from './fields/Textarea';
    import fieldImage from './fields/ImageEditor';
    import fieldVideo from './fields/Video';
    import fieldGallery from './fields/Gallery';
    import fieldProducts from './fields/Products';
    import fieldPages from './fields/Pages';
    import fieldArticleType from './fields/ArticleType';
    import fieldArticleTag from './fields/ArticleTag';
    import fieldArticles from './fields/Articles';
    import fieldArticleCategory from './fields/ArticleCategory';
    import fieldLeftRight from './fields/LeftRight';
    import fieldTextColor from './fields/TextColor';
    import fieldCkeditor from './fields/Ckeditor';
    import fieldTitleSize from './fields/TitleSize';
    import fieldBackgroundColor from './fields/BackgroundColor';

    export default {
        components: {
            fieldInput,
            fieldInputEnterable,
            fieldNumber,
            fieldCheckbox,
            fieldTextarea,
            fieldImage,
            fieldVideo,
            fieldGallery,
            fieldProducts,
            fieldPages,
            fieldArticleType,
            fieldArticleTag,
            fieldArticles,
            fieldArticleCategory,
            fieldLeftRight,
            fieldTextColor,
            fieldCkeditor,
            fieldTitleSize,
            fieldBackgroundColor,
        },
        props: {
            row: {
                required: true,
                type: Object
            }
        },
        data: function () {
            return {
                currentData: {},
            }
        },
        methods: {
            getData() {
                return this.currentData;
            },
            isField(name, field) {
                if (name instanceof RegExp === false) {
                    name = new RegExp(`^(${name}(_([0-9]+))?)*$`);
                }

                return name.test(field);
            },
            update(payload) {
                let data = this.currentData;

                if (payload.hasOwnProperty('lang')) {
                    if (data.hasOwnProperty(payload.field) === false) {
                        data[payload.field] = {};
                    }

                    data[payload.field][payload.lang] = payload.value;
                } else {
                    data[payload.field] = payload.value;
                }

                this.currentData = data;
            },
        },
        computed: {
            visibleFields() {
                return this.row.groupedData;
            },
            toggleFields() {
                return this.visibleFields.toggles;
            },
            globalFields() {
                return this.visibleFields.globals;
            },
            translatableFields() {
                return this.visibleFields.translations;
            },
            hasTranslatableFields() {
                return Object.keys(this.translatableFields).length > 0;
            },
            isDummy() {
                return (this.toggleFields.length + this.globalFields.length + this.translatableFields.length) === 0;
            },
        },
        watch: {},
        mounted() {
        },
        created() {
        }

    }
</script>

<style scoped>

</style>
